import { render, staticRenderFns } from "./ClientAddresses.vue?vue&type=template&id=1168f098"
import script from "./ClientAddresses.vue?vue&type=script&lang=js"
export * from "./ClientAddresses.vue?vue&type=script&lang=js"
import style0 from "./ClientAddresses.vue?vue&type=style&index=0&id=1168f098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports